import { render, staticRenderFns } from "./campaign_category.vue?vue&type=template&id=6081a0de&scoped=true&"
import script from "./campaign_category.vue?vue&type=script&lang=js&"
export * from "./campaign_category.vue?vue&type=script&lang=js&"
import style0 from "./campaign_category.vue?vue&type=style&index=0&id=6081a0de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081a0de",
  null
  
)

export default component.exports